import time from '../time';

export default class Mutext {
    private isLock = false;
    public async Lock() {
        while (this.isLock) {
            await time.sleep(10);
        }
        this.isLock = true;
    }
    public UnLock() {
        this.isLock = false;
    }
}
